export const getValue = (value: any) =>
  value === ""
    ? { caseno: "", report: [] }
    : typeof value === "string"
      ? { caseno: value, report: [] }
      : value;
